import type { ExtensionApi } from './extension';
import type { ThemeConfig, LayerSelector } from './theme';
import { getLayer } from '../layer';

export class View {
  render(api: ExtensionApi, ...args: any[]) {
    throw new Error('`render` method is not implemented.');
  }

  destroy() {
    throw new Error('`destroy` method is not implemented.');
  }

  /**
   * 切换主题
   * @param api ExtensionApi实例
   * @param themeConfig 新的主题配置
   * @param layerSelector 可选的层选择器
   */
  switchTheme(api: ExtensionApi, themeConfig: ThemeConfig, layerSelector?: LayerSelector): void {
    console.log(`View switchTheme called: ${themeConfig.name}`, layerSelector);

    // 更新api中的主题配置
    api.themeConfig = themeConfig;

    // 解析layer选择器
    const targetLayers = this.parseLayerSelector(layerSelector);

    // 获取当前的layers信息
    const currentSpec = api.spec;
    const layerTypes = currentSpec.view.main.layers?.map(layer => layer.type) || [];

    const layersToSwitch = targetLayers || layerTypes;

    layersToSwitch.forEach(layerId => {
      try {
        // 获取layer实例
        const layers = getLayer(layerId);
        console.log('layers: ', layers);

        if (layers && layers.switchTheme) {
          console.log(`Switching theme for layer: ${layerId}`);
          layers.switchTheme(api, themeConfig);
          console.log(`Layer ${layerId} theme switched to: ${themeConfig.name}`);
        } else {
          console.warn(`Layer ${layerId} does not support theme switching`);
        }
      } catch (error) {
        console.error(`Layer ${layerId} theme switch failed:`, error);
      }
    });

    // 触发主题切换事件
    api.lifecycle?.emit('theme:switched', {
      theme: themeConfig,
      targetLayers: layersToSwitch,
      timestamp: Date.now()
    });

    console.log(`View theme switch completed for layers: ${layersToSwitch.join(', ')}`);
  }

  /**
   * 解析layer选择器的辅助函数
   */
  private parseLayerSelector(selector?: LayerSelector): string[] | null {
    if (!selector) {
      return null;
    }
    if (typeof selector === 'string') {
      return [selector];
    }
    if (Array.isArray(selector)) {
      return selector;
    }
    if (typeof selector === 'object' && selector.layers) {
      return selector.layers;
    }
    return null;
  }
}
